import React from 'react';
import { Link } from 'react-router-dom';
import { siteData } from '../data/mockData';
import { useLanguage } from '../context/LanguageContext';
import { useTranslation } from '../data/translations';

const Footer = () => {
  const { lang } = useLanguage();
  const { t, get } = useTranslation(lang);

  return (
    <footer className="relative py-20 md:py-28" style={{ background: '#f0f0f0' }}>
      <div className="px-8 md:px-16 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div>
            <p className="text-sm font-bold tracking-[0.2em] uppercase text-gray-900 mb-4">{siteData.company.name}</p>
            <h2 className="text-5xl md:text-7xl lg:text-8xl font-black italic leading-[0.95]" style={{ color: '#A855F7' }}>We make<br />spaces work.</h2>
          </div>
          <div className="space-y-8 lg:pt-4">
            <div>
              <h4 className="text-sm font-bold tracking-[0.15em] uppercase mb-2" style={{ color: '#A855F7' }}>{get(t.footer.bel)}</h4>
              <p className="text-gray-700 text-base">{siteData.footer.contact.bel.items.map((item, i) => (<span key={i}>{i > 0 && ' | '}<span className="font-medium">{item.prefix}</span> <a href={`tel:${item.number}`} className="hover:text-[#A855F7] transition-colors duration-300">{item.number}</a></span>))}</p>
            </div>
            <div>
              <h4 className="text-sm font-bold tracking-[0.15em] uppercase mb-2" style={{ color: '#A855F7' }}>{get(t.footer.mail)}</h4>
              <a href={`mailto:${siteData.footer.contact.mail.email}`} className="text-gray-700 text-base hover:text-[#A855F7] transition-colors duration-300">{siteData.footer.contact.mail.email}</a>
            </div>
            <div>
              <h4 className="text-sm font-bold tracking-[0.15em] uppercase mb-2" style={{ color: '#A855F7' }}>{get(t.footer.kantoor)}</h4>
              <p className="text-gray-700 text-base">{siteData.footer.contact.kantoor.address}</p>
            </div>
            <div>
              <h4 className="text-sm font-bold tracking-[0.15em] uppercase mb-2" style={{ color: '#A855F7' }}>{get(t.footer.socials)}</h4>
              <div className="flex items-center gap-3 text-gray-700 text-base">
                {siteData.footer.contact.socials.links.map((link, i) => (<span key={link.name}>{i > 0 && <span className="mx-2 text-gray-400">|</span>}<a href={link.url} target="_blank" rel="noopener noreferrer" className="hover:text-[#A855F7] transition-colors duration-300">{link.name}</a></span>))}
              </div>
            </div>
          </div>
        </div>
        <div className="mt-16 pt-6 border-t border-gray-300 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-gray-500">&copy; {new Date().getFullYear()} Cobras Architects. Experience by design.</p>
          <Link to="/privacy" className="text-sm text-gray-500 hover:text-[#A855F7] transition-colors">
            {get(t.privacy.title)}
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
